import type React from "react";

import { Collapsible, IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { StyledTitleSection } from "app/pages/sales-intelligence/modules/ai-agent/components/CollapsedBriefSection/styles";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";

type Props = {
    title: React.ReactNode;
    children: React.ReactNode[];
    isCollapsed: boolean;
    onCollapse: (isCollapsed: boolean) => void;
    trackingName: string;
};

const removeEmojis = (str: string): string => {
    return str.replace(
        /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}]/gu,
        "",
    );
};

export const CollapsedBriefSection: React.FC<Props> = ({ title, children, isCollapsed, onCollapse, trackingName }) => {
    const handleToggle = () => {
        onCollapse(!isCollapsed);
        AIAgentTrackingService.meeting.trackBriefMessageToggle(isCollapsed, removeEmojis(trackingName));
    };

    return (
        <>
            <StyledTitleSection
                isCollapsed={isCollapsed}
                onClick={handleToggle}
            >
                {title}
                <Tooltip
                    content={translate(
                        isCollapsed ? "si.page.ai_agent.message.expand" : "si.page.ai_agent.message.collapse",
                    )}
                >
                    <div>
                        <IconButton
                            iconName={isCollapsed ? "chev-down" : "chev-up"}
                            type="flat"
                            dataAutomation="toggle-section-button"
                        />
                    </div>
                </Tooltip>
            </StyledTitleSection>
            <Collapsible isActive={!isCollapsed}>{children}</Collapsible>
        </>
    );
};
